/* Skalierung von Rezept-Zutaten auf Personen + Aufrunden auf Packungsgroessen.
   Spiegelt die Logik von backend/hilfen.php (EinheitBasis) bzw.
   backend/einkaufslisteAusPlanung.php - bei Aenderungen beide Seiten anpassen. */

export function EinheitBasis(Einheit) {
  switch (Einheit) {
    case 'Gramm': return { Dimension: 'Masse', Faktor: 1 }
    case 'Kg': return { Dimension: 'Masse', Faktor: 1000 }
    case 'ml': return { Dimension: 'Volumen', Faktor: 1 }
    case 'Liter': return { Dimension: 'Volumen', Faktor: 1000 }
    case 'Volumen': return { Dimension: 'VolumenAlt', Faktor: 1 }
    case 'Stück': return { Dimension: 'Stueck', Faktor: 1 }
    case 'Flasche': return { Dimension: 'Flasche', Faktor: 1 }
    case 'Packung': return { Dimension: 'Packung', Faktor: 1 }
    case 'EL': return { Dimension: 'EL', Faktor: 1 }
    case 'Netz': return { Dimension: 'Netz', Faktor: 1 }
    default: return null
  }
}

/* Skaliert die Menge einer Rezept-Zutat und rundet auf ganze Packungen auf.
   Rueckgabe: { Anzahl, SkalierteMenge } - SkalierteMenge nur wenn berechenbar (sonst null),
   Anzahl ist immer mindestens 1. */
export function PackungsBedarf(RezeptZutat, Zutat, PersonenFaktor) {
  const RezeptBasis = EinheitBasis(RezeptZutat.Einheit)
  const PackungsBasis = EinheitBasis(Zutat?.Einheit)
  const PackungsMenge = Zutat?.Menge != null ? Number(Zutat.Menge) : 0
  const SkalierteMenge = RezeptZutat.Menge != null ? Number(RezeptZutat.Menge) * PersonenFaktor : null

  const Umrechenbar = SkalierteMenge !== null && RezeptBasis && PackungsBasis
    && RezeptBasis.Dimension === PackungsBasis.Dimension && PackungsMenge > 0

  if (!Umrechenbar) {
    return { Anzahl: Math.max(1, Math.ceil(PersonenFaktor)), SkalierteMenge }
  }

  const BedarfBasis = SkalierteMenge * RezeptBasis.Faktor
  const PackungsGroesse = PackungsMenge * PackungsBasis.Faktor
  const Anzahl = Math.max(1, Math.ceil(Math.round((BedarfBasis / PackungsGroesse) * 1e6) / 1e6))
  return { Anzahl, SkalierteMenge }
}

/* Kompakte Mengen-Anzeige, z.B. "800 Gramm" oder "1.5 Liter" */
export function MengeFormatieren(Menge, Einheit) {
  if (Menge == null) return Einheit || ''
  const Gerundet = Math.round(Number(Menge) * 100) / 100
  return `${Gerundet} ${Einheit || ''}`.trim()
}
